import conceptIcon from "../assets/bjelin-concept.svg";
import outletIcon from "../assets/bjelin-outlet.svg";
import conceptIconDark from "../assets/bjelin-concept-darkbg.svg";

export default function BjelinLogo({
  variant = "bjelin",
  darkBG = false,
  asText = false,
  bold = false,
  style = {}
}) {
  if (variant === "outlet") {
    return <OutletLogo asText={asText} bold={bold} style={style} />;
  } else if (variant === "concept") {
    return (
      <ConceptLogo asText={asText} bold={bold} style={style} darkBG={darkBG} />
    );
  } else {
    <div>Bjelin</div>;
  }
}

function OutletLogo({ asText = false, bold = false, style = {} }) {
  return asText ? (
    <span style={{ display: "inline-flex", alignItems: "center", ...style }}>
      <span
        style={{
          display: "inline-block",
          height: "1.2em",
          lineHeight: "1.2em",
          marginRight: "0.2em",
          fontFamily: "Bjelin",
          fontWeight: bold ? 700 : 400,
          fontSize: "1em",
          letterSpacing: 0
        }}
      >
        BJELIN
      </span>

      <span
        style={{
          display: "inline-block",
          padding: "0 0.2em",
          marginBottom: "0.3em",
          background: "#9aa27d",
          color: "#fff",
          height: "1.4em",
          lineHeight: "1.4em",
          fontSize: "0.7em",
          fontWeight: bold ? 900 : 600,
          letterSpacing: "-0.02em",
          textShadow: "none"
        }}
      >
        OUTLET
      </span>
    </span>
  ) : (
    <img
      alt="Bjelin OUTLET"
      src={outletIcon}
      style={{ display: "inline-block", height: "0.9em", ...style }}
    />
  );
}

function ConceptLogo({
  darkBG = false,
  asText = false,
  bold = false,
  style = {}
}) {
  return asText ? (
    <span style={{ display: "inline-flex", alignItems: "center", ...style }}>
      <span
        style={{
          display: "inline-block",
          height: "1.2em",
          lineHeight: "1.2em",
          marginRight: "0.2em",
          fontFamily: "Bjelin",
          fontWeight: bold ? 700 : 400,
          fontSize: "1em",
          letterSpacing: 0,
          color: darkBG ? "#fff" : "#333"
        }}
      >
        BJELIN
      </span>

      <span
        style={{
          display: "inline-block",
          padding: "0 0.2em",
          marginBottom: "0.3em",
          background: darkBG ? "#fff" : "#333",
          color: darkBG ? "#333" : "#fff",
          height: "1.4em",
          lineHeight: "1.4em",
          fontSize: "0.7em",
          fontWeight: bold ? 900 : 600,
          letterSpacing: "-0.02em",
          textShadow: "none"
        }}
      >
        CONCEPT
      </span>
    </span>
  ) : (
    <img
      alt="Bjelin CONCEPT"
      src={darkBG ? conceptIconDark : conceptIcon}
      style={{ display: "inline-block", height: "0.9em", ...style }}
    />
  );
}
